import { Authority } from 'platform/app/authority.constant';

export const CAMPAIGN = {
    name: 'Campaign',
    path: '/campaign',
    icon: 'dm-layers',
    requiresAuthority: Authority.ROLE_CAMPAIGNS_VIEW_EDIT,
};
